import React, { useState, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import api from "../../services/api";
import PageBar from "../../components/common/PageBar";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import DashboardDiv from "../../components/common/DashboardDiv";
import SearchButton from "../../components/common/SearchButton";
import CustomDatePicker from "../../components/common/CustomDatePicker";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";

const ErrorReportingLogManagementPage = () => {
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 15;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());

  const [last30DaysAllError, setLast30DaysAllError] = useState("");
  const [totalAppError, setTotalAppError] = useState("");
  const [totalWebError, setTotalWebError] = useState("");
  const [recentAppError, setRecentAppError] = useState("");
  const [recentWebError, setRecentWebError] = useState("");

  const [data, setData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/error-report/view", {
        pageNo: curPage,
        pageSize: pageSize,
        startDt: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        endDt: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      })
      .then((response) => {
        setData(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});

    api
      .post("/manage/error-report/count", {
        startDt: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        endDt: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
      })
      .then((response) => {
        setLast30DaysAllError(response.data.last30DaysAllError);
        setTotalAppError(response.data.totalAppError);
        setTotalWebError(response.data.totalWebError);
        setRecentAppError(response.data.recentAppError);
        setRecentWebError(response.data.recentWebError);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const handleStartDateChange = (data) => {
    setStartDate(data);
    if (moment(data).isAfter(moment(endDate))) {
      setEndDate(data);
    }
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
    if (moment(data).isBefore(moment(startDate))) {
      setStartDate(data);
    }
  };

  const handleSearch = () => {
    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const decodeHtml = (html) => {
    const tsb = document.createElement("textarea");
    tsb.innerHTML = html;
    return tsb.value;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0426")]} />

      <SearchWrapDiv>
        <ButtonWrapDiv className="btn_right">
          <CustomDatePicker
            defaultDate={startDate}
            maxDate={new Date()}
            onChange={(date) => handleStartDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <div>
            <br />
            &nbsp;&nbsp;-&nbsp;&nbsp;
          </div>
          <CustomDatePicker
            defaultDate={endDate}
            maxDate={new Date()}
            onChange={(date) => handleEndDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <DashboardDiv>
          <dl>
            <dt>{t("L0431")}</dt>
            <dd>{last30DaysAllError ? last30DaysAllError : 0}</dd>
          </dl>
          <dl>
            <dt>{t("L0432")} (Total)</dt>
            <dd>{totalAppError ? totalAppError : 0}</dd>
          </dl>
          <dl>
            <dt>{t("L0432")} (Period)</dt>
            <dd>{recentAppError ? recentAppError : 0}</dd>
          </dl>
          <dl>
            <dt>{t("L0434")} (Total)</dt>
            <dd>{totalWebError ? totalWebError : 0}</dd>
          </dl>
          <dl>
            <dt>{t("L0434")} (Period)</dt>
            <dd>{recentWebError ? recentWebError : 0}</dd>
          </dl>
        </DashboardDiv>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "49%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>No.</th>
                <th>{t("L0438")}</th>
                <th>
                  {t("L0727")} {t("L0339")}
                </th>
                <th>
                  {t("L0245")} {t("L0141")}
                </th>
                <th>{t("L0437")}</th>
                <th>{t("L0439")}</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                data.map((data, index) => (
                  <tr key={data.id}>
                    <td>{(curPage - 1) * pageSize + index + 1}</td>
                    <td>{data.logType}</td>
                    <td>{data.mobileInfo}</td>
                    <td>{data.appVersion}</td>
                    <td style={{ wordBreak: "break-all" }}>
                      {decodeHtml(decodeHtml(data.logContent))}
                    </td>
                    <td>
                      {moment(data.logSaveTime).format("YYYY-MM-DD a h:mm:ss")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        />
      </LoadingBoxDiv>
    </div>
  );
};

export default ErrorReportingLogManagementPage;
